import { Box, BoxProps, Theme, useTheme } from '@hover/blueprint';
import React from 'react';
import styled from 'styled-components';

interface IconProps extends BoxProps {
  color: keyof Theme['colors'];
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  iconWidth?: string | number | undefined;
  iconHeight?: string | number | undefined;
}

/**
 * TODO: Update the Color css property to the accent prop once our svg's support that
 */
const IconWrapper = styled(Box)<{
  color: string;
  accent: string;
  spacing: string;
}>`
  color: ${props => props.color};
  fill: ${props => props.color};
  stroke: ${props => props.color};
  padding: ${props => props.spacing};
`;

const CustomIcon = ({
  icon: IconComponent,
  color,
  iconWidth,
  iconHeight,
  ...props
}: IconProps) => {
  const {
    colors,
    iconStyles: { medium },
  } = useTheme();
  return (
    <IconWrapper
      alignItems="center"
      justifyContent="center"
      {...props}
      color={colors[color]}
      spacing={medium.margin}
    >
      <IconComponent
        height={iconHeight || medium.height}
        width={iconWidth || medium.width}
      />
    </IconWrapper>
  );
};

export { CustomIcon };
